import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import menu_icon from "../assets/icon/menu_icon.svg";
import menu_iconX from "../assets/icon/x_icon.svg";
import logo from "../assets/logo/logo.svg";
import ChevronDownIcon from "../assets/icon/chevron-down.svg";

const headerNavLink = [
	{
		id: "homemenu",
		link: "/",
		text: "Home",
		isLandingPage: false,
	},
	{
		id: "pluginmenu",
		link: "/plugins",
		text: "Plugins",
		isLandingPage: false,
	},
	{
		id: "feadbackmenu",
		link: "feedback",
		text: "Feedback",
		isLandingPage: false,
	},
	{
		id: "docsandhelpmenu",
		link: "/help-and-docs",
		text: "Help & Docs",
		isLandingPage: false,
		isHaveSubmenu: true,
	}
];

function Header() {
	const [openNavbar, setOpenNavbar] = useState(false);
	
	// Canny changelog
	useEffect(() => {
		Canny('initChangelog', {
			appID: process.env.REACT_APP_CANNY_APP_ID,
			position: 'bottom',
			align: 'left',
		 });
	}, []);

	return (
		<div className="shadow-md">
			<div className="container mx-auto px-5 3xl:px-0 max-w-7xl">
				{/* Logo */}
				<div className="flex justify-between h-[64px] md:h-[77px] 2xl:h-[92px] items-center">
					<Link to="/">
						<img
							src={logo}
							alt="Logo"
							className="w-[126px] md:w-[160px] 2xl:w-[179px]"
						/>
					</Link>
					<div className="space-x-12 hidden lg:flex flex-nowrap items-center font-medium">
						{headerNavLink.map((link) =>
							link?.isLandingPage ? (
								<a
									href={link.link}
									key={link.id}
									className="navLinkHover"
									target="_blank"
								>
									{link.text}
								</a>
							) : !link?.isLandingPage &&
							  link?.text === "Demo" ? (
								<HashLink key={link.id} smooth to="#homepages">
									{link.text}
								</HashLink>
							) : (
								<NavLink
									key={link.id}
									to={link.link}
									className="navLinkHover flex items-center gap-1 relative group/item"
								>
									{link.text}
									{/* hover menu */}
									{link?.isHaveSubmenu && (
										<img className="h-3.5 w-3.5" src={ChevronDownIcon} alt="chevron-down" />
									)}
									{link?.isHaveSubmenu && (
										<div className={`absolute p-1 border border-[#ddd] invisible group-hover/item:visible z-50 left-0 top-6 overflow-hidden min-h-[52px] min-w-[120px] rounded-sm bg-white shadow-sm`}>
											<button data-canny-changelog className="my-1 bg-black rounded-sm hover:bg-yellow transition w-full p-1 text-white hover:text-black">Changelog</button>
										</div>
									)}
								</NavLink>
							)
						)}
						<a
							href="https://codecanyon.net/item/martvill-a-global-multivendor-ecommerce-platform-to-sell-anything/43288879"
							target="_blank"
							rel="noopener noreferrer"
						>
							<button className="px-[47.5px] py-[13px] buyNow bg-black text-white  flex items-center space-x-[9px] rounded-sm hover:text-black hover:bg-yellow">
								<span>
									<svg
										width="14"
										height="14"
										viewBox="0 0 14 14"
										fill="white"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M3.46094 6.37558C3.46094 6.76681 3.7781 7.08397 4.16934 7.08397C4.56057 7.08397 4.87773 6.76681 4.87773 6.37558V4.95879H9.12812V6.37557C9.12812 6.76681 9.44528 7.08397 9.83652 7.08397C10.2278 7.08397 10.5449 6.76681 10.5449 6.37557V4.95993C10.9191 4.96256 11.1928 4.97125 11.4117 4.99967C11.6956 5.03653 11.7892 5.09625 11.8432 5.14589C11.8972 5.19554 11.9644 5.28389 12.0248 5.56373C12.0893 5.86344 12.1248 6.27181 12.1778 6.9075L12.5418 11.2755C12.5734 11.6553 12.5894 11.8668 12.5814 12.0145L12.581 12.0201L12.5755 12.0209C12.429 12.0412 12.2169 12.0428 11.8358 12.0428H2.16419C1.78308 12.0428 1.57103 12.0412 1.42454 12.0209L1.41896 12.0201L1.41863 12.0145C1.41058 11.8668 1.42659 11.6553 1.45824 11.2755L1.82225 6.9075C1.87522 6.27181 1.91065 5.86343 1.97524 5.56373C2.03556 5.28389 2.10284 5.19554 2.15679 5.14589C2.21075 5.09625 2.30438 5.03653 2.58827 4.99967C2.80829 4.9711 3.08375 4.96248 3.46094 4.95989V6.37558ZM4.87773 3.542L9.12812 3.542V3.54198C9.12812 2.36827 8.17664 1.41679 7.00293 1.41679C5.82921 1.41679 4.87773 2.36827 4.87773 3.54198V3.542ZM10.5449 3.54292V3.54198C10.5449 1.5858 8.95911 0 7.00293 0C5.04674 0 3.46094 1.5858 3.46094 3.54199V3.54288C3.06116 3.54548 2.70688 3.55558 2.40583 3.59467C1.96928 3.65136 1.55019 3.77874 1.19747 4.1033C0.844744 4.42785 0.682993 4.83491 0.590249 5.26524C0.503967 5.66559 0.462224 6.16685 0.414015 6.74576L0.410344 6.78984L0.0463399 11.1579L0.0429543 11.1985C0.0159157 11.5222 -0.0101183 11.8339 0.00394115 12.0916C0.0196997 12.3805 0.0893808 12.717 0.351711 13.0021C0.614042 13.2872 0.943552 13.3846 1.23016 13.4243C1.48514 13.4596 1.79688 13.4596 2.12074 13.4596H2.12348H2.16419H11.8358H11.8765H11.8792C12.2032 13.4596 12.5148 13.4596 12.7698 13.4243C13.0564 13.3846 13.386 13.2872 13.6483 13.0021C13.9106 12.717 13.9803 12.3805 13.9961 12.0916C14.0101 11.8339 13.9841 11.5222 13.957 11.1985L13.9537 11.1579L13.586 6.74575C13.5378 6.16684 13.496 5.66559 13.4098 5.26524C13.317 4.83491 13.1553 4.42785 12.8025 4.1033C12.4498 3.77874 12.0307 3.65136 11.5942 3.59467C11.2946 3.55577 10.9423 3.54558 10.5449 3.54292Z"
										/>
									</svg>
								</span>
								<span className="text-[15px] font-medium leading-[20px]">
									Buy Now
								</span>{" "}
							</button>
						</a>
					</div>
					<div className="cursor-pointer block lg:hidden">
						{openNavbar === false ? (
							<img
								className="-scale-x-100"
								src={menu_icon}
								onClick={() => setOpenNavbar(true)}
								alt=""
							/>
						) : (
							<img
								className="-scale-x-100"
								src={menu_iconX}
								onClick={() => setOpenNavbar(false)}
								alt=""
							/>
						)}
					</div>
				</div>
				{/* Mobile Navbar */}
				<div
					className={
						openNavbar === true
							? "block lg:hidden mt-[17px]"
							: "hidden lg:hidden mt-[17px]"
					}
				>
					<div className="bg-white h-auto pb-16  w-full">
						<div className="space-y-9  flex flex-col items-center font-medium">
							{headerNavLink.map((link) =>
								link?.isLandingPage ? (
									<a
										href={link.link}
										key={link.id}
										className="navLinkHover"
										target="_blank"
									>
										{link.text}
									</a>
								) : !link?.isLandingPage &&
								  link?.text === "Demo" ? (
									<HashLink
										key={link.id}
										smooth
										to="#homepages"
									>
										{link.text}
									</HashLink>
								) : (
									<NavLink
										key={link.id}
										to={link.link}
										className="navLinkHover flex items-center gap-1 relative group/item"
									>
										{link.text}
										{/* hover menu */}
										{link?.isHaveSubmenu && (
											<img className="h-3.5 w-3.5" src={ChevronDownIcon} alt="chevron-down" />
										)}
										{link?.isHaveSubmenu && (
											<div className={`absolute p-1 border border-[#ddd] invisible group-hover/item:visible z-50 left-0 top-6 overflow-hidden min-h-[52px] min-w-[120px] rounded-sm bg-white shadow-sm`}>
												<button data-canny-changelog className="my-1 bg-black rounded-sm hover:bg-yellow transition w-full p-1 text-white hover:text-black">Changelog</button>
											</div>
										)}
									</NavLink>
								)
							)}
							<a
								href="https://codecanyon.net/item/martvill-a-global-multivendor-ecommerce-platform-to-sell-anything/43288879"
								target="_blank"
								rel="noopener noreferrer"
							>
								<button className="px-[47.5px] py-[13px] buyNow bg-black text-white  flex items-center space-x-[9px] rounded-sm hover:text-black hover:bg-yellow">
									<span>
										<svg
											width="14"
											height="14"
											viewBox="0 0 14 14"
											fill="white"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fillRule="evenodd"
												clipRule="evenodd"
												d="M3.46094 6.37558C3.46094 6.76681 3.7781 7.08397 4.16934 7.08397C4.56057 7.08397 4.87773 6.76681 4.87773 6.37558V4.95879H9.12812V6.37557C9.12812 6.76681 9.44528 7.08397 9.83652 7.08397C10.2278 7.08397 10.5449 6.76681 10.5449 6.37557V4.95993C10.9191 4.96256 11.1928 4.97125 11.4117 4.99967C11.6956 5.03653 11.7892 5.09625 11.8432 5.14589C11.8972 5.19554 11.9644 5.28389 12.0248 5.56373C12.0893 5.86344 12.1248 6.27181 12.1778 6.9075L12.5418 11.2755C12.5734 11.6553 12.5894 11.8668 12.5814 12.0145L12.581 12.0201L12.5755 12.0209C12.429 12.0412 12.2169 12.0428 11.8358 12.0428H2.16419C1.78308 12.0428 1.57103 12.0412 1.42454 12.0209L1.41896 12.0201L1.41863 12.0145C1.41058 11.8668 1.42659 11.6553 1.45824 11.2755L1.82225 6.9075C1.87522 6.27181 1.91065 5.86343 1.97524 5.56373C2.03556 5.28389 2.10284 5.19554 2.15679 5.14589C2.21075 5.09625 2.30438 5.03653 2.58827 4.99967C2.80829 4.9711 3.08375 4.96248 3.46094 4.95989V6.37558ZM4.87773 3.542L9.12812 3.542V3.54198C9.12812 2.36827 8.17664 1.41679 7.00293 1.41679C5.82921 1.41679 4.87773 2.36827 4.87773 3.54198V3.542ZM10.5449 3.54292V3.54198C10.5449 1.5858 8.95911 0 7.00293 0C5.04674 0 3.46094 1.5858 3.46094 3.54199V3.54288C3.06116 3.54548 2.70688 3.55558 2.40583 3.59467C1.96928 3.65136 1.55019 3.77874 1.19747 4.1033C0.844744 4.42785 0.682993 4.83491 0.590249 5.26524C0.503967 5.66559 0.462224 6.16685 0.414015 6.74576L0.410344 6.78984L0.0463399 11.1579L0.0429543 11.1985C0.0159157 11.5222 -0.0101183 11.8339 0.00394115 12.0916C0.0196997 12.3805 0.0893808 12.717 0.351711 13.0021C0.614042 13.2872 0.943552 13.3846 1.23016 13.4243C1.48514 13.4596 1.79688 13.4596 2.12074 13.4596H2.12348H2.16419H11.8358H11.8765H11.8792C12.2032 13.4596 12.5148 13.4596 12.7698 13.4243C13.0564 13.3846 13.386 13.2872 13.6483 13.0021C13.9106 12.717 13.9803 12.3805 13.9961 12.0916C14.0101 11.8339 13.9841 11.5222 13.957 11.1985L13.9537 11.1579L13.586 6.74575C13.5378 6.16684 13.496 5.66559 13.4098 5.26524C13.317 4.83491 13.1553 4.42785 12.8025 4.1033C12.4498 3.77874 12.0307 3.65136 11.5942 3.59467C11.2946 3.55577 10.9423 3.54558 10.5449 3.54292Z"
											/>
										</svg>
									</span>
									<span className="text-[15px] font-medium leading-[20px]">
										Buy Now
									</span>{" "}
								</button>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Header;
